export default __webpack_public_path__ + "static/media/sectionsAdaptiveTestFlow.33172ea9.png";